import { StateComponent } from "~/ecs/base"

export class FaceMapColorsApplied extends StateComponent {}
